import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_CommonBed, standardWeight_GearedMotorBed } from '../../../lib/data/standard-weight';

const CommonBedForm = ({ onSaveStructure, onChangeWeightSummary, commonBeds, selectedMotor }) => {
    const [isShow, setIsShow] = useState(commonBeds?.length || false);
    const [newCommonBed, setNewCommonBed] = useState(commonBeds || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [driveTypeCategory, setDriveTypeCategory] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    const driveTypeCategoryText = useRef({
        0: 'Common Drive',
        1: 'Geared Motor',
    });

    /*  처음 props로 넘어온 commonBeds를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialCommonBed = useRef(commonBeds || []);

    /* categoryType에 따라 standardWeight를 가져오는 함수 */
    const getStandardWeight = useCallback(() => {
        let weight = 0;
        if (driveTypeCategory === '0') {
            const object = standardWeight_CommonBed.find((item) => item.standardPower >= parseInt(selectedMotor));
            if (!object) return;
            weight = object.standardWeight;
        } else {
            const object = standardWeight_GearedMotorBed.find((item) => item.standardPower >= Number(selectedMotor));
            if (!object) return;
            weight = object.standardWeight;
        }
        return weight;
    }, [driveTypeCategory, selectedMotor]);

    /* Category를 선택하면 해당하는 standardWeight를 가져온다 */
    useEffect(() => {
        if (!driveTypeCategory) return;

        const _standardWeight = getStandardWeight(driveTypeCategory);
        const _unitWeight = Math.ceil(_standardWeight * factor);
        setStandardWeight(_standardWeight);
        setUnitWeight(_unitWeight);
    }, [driveTypeCategory, getStandardWeight, factor]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor || !qty) {
        //     return;
        // }
        // setUnitWeight(Math.ceil(standardWeight * factor));
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newCommonBed.length) {
            return 0;
        }
        return Math.max(...newCommonBed.map((item) => Number(item.id.substring(3))), 0);
    }, [newCommonBed]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`CB-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newCommonBed에 commonBed 추가 */
    const onAddCommonBed = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const commonBed = {
            id,
            commonBedTypeCategory:
                driveTypeCategoryText.current[`${driveTypeCategory}`] + ` Bed for ${selectedMotor}kW`,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewCommonBed((prev) => [...prev, commonBed]);
        setIsChanged(true);
    }, [id, driveTypeCategory, selectedMotor, standardWeight, factor, qty, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 commonBed 삭제 */
    const onDeleteCommonBed = useCallback((id) => {
        setNewCommonBed((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newCommonBed에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newCommonBed);
        getTotalWeight(newCommonBed);
        initializeForm();
        onSaveStructure({
            key: 'commonBed',
            value: newCommonBed,
        });
        onChangeWeightSummary({
            key: 'commonBed',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newCommonBed,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveCommonBed = useCallback(() => {
    //     onSaveStructure({
    //         key: 'commonBed',
    //         value: newCommonBed,
    //     });
    //     onChangeWeightSummary({
    //         key: 'commonBed',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newCommonBed, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newCommonBed를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewCommonBed(initialCommonBed.current);
    //     onSaveStructure({
    //         key: 'commonBed',
    //         value: initialCommonBed.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'commonBed',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <CommonBedFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Common Bed</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type</th>
                                <th>
                                    Motor Power
                                    <br />
                                    (kW)
                                </th>
                                <th>
                                    Standard W't
                                    <br />
                                    (kg/m3)
                                </th>
                                <th>Factor</th>
                                <th>
                                    단위중량
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newCommonBed &&
                                newCommonBed.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.commonBedTypeCategory}</td>
                                        <td>{selectedMotor}</td>
                                        <td>{item.standardWeight}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteCommonBed(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td className="td-radio">
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="driveTypeCategory"
                                                value="0"
                                                onChange={(e) => setDriveTypeCategory(e.target.value)}
                                            />
                                            <span>Common Drive</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="driveTypeCategory"
                                                value="1"
                                                onChange={(e) => setDriveTypeCategory(e.target.value)}
                                            />
                                            <span>Geared Motor</span>
                                        </label>
                                    </div>
                                </td>
                                <td>{selectedMotor}</td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddCommonBed}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>CommonBed Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveCommonBed} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </CommonBedFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const CommonBedFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }

    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default CommonBedForm;
